import { AHWidgetTitle, TouchableBox } from "arkh";
import React from "react";

import { BaseWidgetProps } from "../BaseProps";
import { useSetWidgetFocus } from "../useSetFocus";
import { useSetScrollFocusMutation } from "../Focus/useSetFocusScroll";

import { graphql, useFragment } from "react-relay";
import { WidgetEmployeeRoleOverview_widget$key } from "./__generated__/WidgetEmployeeRoleOverview_widget.graphql";

import {
  WidgetEmployeeRoleOverviewContent,
  WidgetEmployeeRoleOverviewContentRef,
} from "./WidgetEmployeeRoleOverviewContent";
import type { WidgetEmployeeRoleOverviewListItemPressData } from "./WidgetEmployeeRoleOverviewListItem";

export const WidgetEmployeeRoleOverview = (
  props: {
    widget: WidgetEmployeeRoleOverview_widget$key;
    ref?: React.RefObject<WidgetEmployeeRoleOverviewContentRef | null>;
    scrollToItemId?: string;
  } & BaseWidgetProps
) => {
  const widget = useFragment(
    graphql`
      fragment WidgetEmployeeRoleOverview_widget on WidgetEmployeeRoleOverview {
        id
        title
        ...WidgetEmployeeRoleOverviewContent_widget
      }
    `,
    props.widget
  );

  const setScroll = useSetScrollFocusMutation(props.storecastId, widget.id);
  const setFocus = useSetWidgetFocus(widget.id, props.storecastId);
  const onPress = () => {
    if (props.mode === "FOCUS" && !props.isFocused) {
      setFocus();
    }
  };

  const onPressRole = (data: WidgetEmployeeRoleOverviewListItemPressData) => {
    props.onEvent?.({
      kind: "EmployeeRoleSelect",
      widgetId: widget.id,
      ...data,
    });
  };

  return (
    <TouchableBox
      disabled={props.mode !== "FOCUS"}
      onPress={() => onPress()}
      style={{ flex: 1 }}
      color="surface"
    >
      <AHWidgetTitle>{widget.title}</AHWidgetTitle>

      <WidgetEmployeeRoleOverviewContent
        ref={props.ref}
        widget={widget}
        interactive={props.interactive}
        isFocused={props.isFocused}
        highlightedItemId={props.highlightedItemId}
        scrollToItemId={props.scrollToItemId}
        setScroll={setScroll}
        onPressRole={
          props.idiom === "TOUCH" && (props.mode !== "FOCUS" || props.isFocused)
            ? onPressRole
            : undefined
        }
      />
    </TouchableBox>
  );
};
